/**
 * Mobile Navigation Animation
 * 
 * @since 1.0.0
 * @package geo_med
 */

(function($) {

	// Dropdown in navigation
	var navCount = 1;
	$('#nav-main .nav-wrapper > ul > li.menu-item-has-children > a').each(function() {
		$(this).attr('data-activates','dropdown'+navCount);
		$(this).addClass('dropdown-button');
		$(this).next('ul').attr({id:'dropdown'+navCount,class:'dropdown-content'});
		navCount += 1;
	});
	$('.dropdown-button').dropdown({
	    inDuration: 300,
	    outDuration: 225,
	    constrainWidth: false, // Does not change width of dropdown to that of the activator
	    hover: true, // Activate on hover
	    gutter: 0, // Spacing from edge
	    belowOrigin: true, // Displays dropdown below the button
	    alignment: 'left', // Displays dropdown with edge aligned to the left of button
	    stopPropagation: false // Stops event propagation
	});

	$("#menu-toggle").sideNav({
		menuWidth: 400
	});

	// moblie slide out nav accordian
	var sideNavCount = 1;
	$('#nav-mobile > ul').attr('data-collapsible','accordian');
	$('#nav-mobile > ul').addClass('collapsible');
	$('#nav-mobile > ul > li.menu-item-has-children > a').each(function() {
		$(this).addClass('collapsible-header');
		$(this).next('ul').addClass('collapsible-body');
		$(this).click(function(e){
			e.preventDefault();
		});
		sideNavCount += 1;
	});
	$('.collapsible').collapsible();
	var $window         = $( window );
	var header          = $( 'header[role=banner]' );
	var nav             = $( 'nav', header );
	var navToggle       = $( '#menu-toggle' );
	navToggle.click( toggleMenu );

	/**
	 * Toggler: toggle class
	 *
	 * @since 1.0.0
	 */
	function toggleMenu() {

		nav.toggleClass( 'toggled' );
		navToggle.toggleClass( 'toggled' );
	}

	/**
	 * Scroll from top detection
	 */

	$(document).on( 'scroll', function() {

		if ($(window).width() <= 1496) {

			if ( $(document).scrollTop() > 0 ) {
				header.addClass( 'scrolled' );
				$('body').addClass( 'scrolled' );
			} else {
				header.removeClass( 'scrolled' );
				$('body').removeClass( 'scrolled' );
			}

		} else {

			if ( $(document).scrollTop() > 54 ) {
				header.addClass( 'scrolled' );
				$('body').addClass( 'scrolled' );
			} else {
				header.removeClass( 'scrolled' );
				$('body').removeClass( 'scrolled' );
			}

		}

	});

	/**
	 * Moves nav footer inside the mobile slideout
	 */

	 $('#nav-footer').appendTo('#slide-out');

})(jQuery);